"use client";

import React from 'react';
import { Zap } from 'lucide-react';

export default function ContactSupportButton() {
    const handleContactClick = (e: React.MouseEvent) => {
        e.preventDefault();
        window.location.href = 'mailto:' + 'corptoolset' + '@' + 'gmail.com';
    };

    return (
        <a 
            href="#" 
            onClick={handleContactClick} 
            className="hover-scale" 
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.75rem',
                background: '#fff',
                color: '#0f172a',
                padding: '1.25rem 3rem',
                borderRadius: '16px',
                fontWeight: 800,
                fontSize: '1.1rem',
                textDecoration: 'none'
            }}
        >
            <Zap size={20} />
            <span>Contact Support</span>
        </a>
    );
}
